module.exports = __webpack_public_path__ + "media/target_area_icon/dept_cs-5608a4d0.png";